import React from 'react';
import ReactApexChart from 'react-apexcharts';

const GradientBarChart = ({data , selectedItem}) => {
    const highestTotalPoints = Math.max(...data.map(it => it.totalPoints));
    const state = {
        series: [{
            name: 'Points',
            data: data?.map(it=> { return  it.totalPoints})
        }],
        options: {
            chart: {
                type: 'bar',
                height: 300,
                width: '100%', // Width in pixels
            },
            responsive: [
                {
                    breakpoint: 1400,  // Example breakpoint
                    options: {
                        chart: {
                            width: '100%',
                            height: 200,

                        }
                    }
                },
                {
                    breakpoint: 1199,  // Example breakpoint
                    options: {
                        chart: {
                            width: '100%',
                            height: 300,

                        }
                    }
                },
                {
                    breakpoint: 768,  // Example breakpoint
                    options: {
                        chart: {
                            width: '100%',
                            height: 200,

                        }
                    }
                }
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    borderRadius: 5,
                    distributed: true
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['#FDFF9F']
            },
            xaxis: {
                categories:  data?.map(it=> { return  it.xLabel}),
                labels: {
                    // rotate: -45,
                    // rotateAlways: true,
                    style: {
                        colors: 'white',  // Set X-axis label colors to white
                        fontSize: '14px',
                        fontFamily: 'Cerebri Sans Pro'
                    }
                },
                axisBorder: {
                    show: true,
                    color: '#97979773',  // Set X-axis line color to red
                    height: 0       // Correct property is 'height' for the thickness of the x-axis line
                }
            },
            yaxis: {
                tickAmount: 5, // Number of ticks on the y-axis
                min: 0,      // Minimum value on the y-axis
                max: selectedItem === 'Weekly' ? 10 : (selectedItem === 'Monthly' ? 70 : 310) ,    // Maximum value on the y-axis
                // title: {
                //     text: 'Sales ($)'
                // },
                labels: {
                    formatter: function(val) {
                        // Round the value to the nearest whole number before displaying
                        return Math.round(val);
                    },
                    style: {
                        colors: 'white',  // Set Y-axis label colors to white
                        fontSize: '12px'
                    }
                },
                axisBorder: {
                    show: true,
                    color: 'transparent',  // Set X-axis line color to red
                    height: 1       // Correct property is 'height' for the thickness of the x-axis line
                }
            },
            grid: {
                borderColor: '#97979773', // Set the color of the grid lines to red
                height:2,
                strokeWidth: 0.5

            },
            fill: {
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shadeIntensity: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#D2A84E',
                            opacity: 0.7
                        },
                        {
                            offset: 100,
                            color: '#D2A84E00',
                            opacity: 0.6
                        }
                    ]
                }
            },
            legend: {
                show: false,  // Hide the legend
            },
            toolbar: {
                show: false,  // Hide the toolbar (options icon)
            },
            tooltip: {
                // enabled: false
                y: {
                    formatter: function (val) {
                        return  val;
                    }
                }
            }
        },
    };



    return (
        <ReactApexChart options={state.options} series={state.series} type="bar" width={'100%'} height={350} />
    );
};

export default GradientBarChart;